export async function getPrecipitationDataOfMonth(month) {
    const data = await $fetch(`/api/weather/precipitation-by-month?month=${month}`)

    Object.entries(data).forEach(([key, value]) => {
        data[key] = Math.round(value)
    })

    data.rainy_days_number = data.rainy_days
    data.rainy_days = numberToWords(data.rainy_days)

    return data
}

export function numberToWords(number) {
    return ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'][number]
}
